module.exports = __webpack_public_path__ + "img/hat-cowboy.15fcc4a6.svg";